import React, { PropTypes } from 'react';
import { Link, IndexLink, browserHistory } from 'react-router';

import { REQUEST_STATUS } from '../../../constants/general';
import RequestSummary from '../../../components/RequestSummary/RequestSummary';

class AdminHomePage extends React.Component {
    constructor(props) {
        super(props);
        // this.chooseUser = this.chooseUser.bind(this);
    }

    render() {
        const {requests, currentUser} = this.props;

        const renderActiveRequests = requests
            .sort((a, b) => {
                return b.requestInfo.requestDate - a.requestInfo.requestDate;
            })
            .map((request, i) => {
                if (!(request.requestInfo.requestStatus === REQUEST_STATUS.delivered ||
                    request.requestInfo.requestStatus === REQUEST_STATUS.denied)) {
                    return (
                        <RequestSummary {...request} key={i} isAdmin={!!(currentUser.permission)}/>
                    );
                }
            });

        return (
            <div className="admin-home-page">
                <h1>Admin Home Page</h1>
                <hr />
                <div className="header"><h3>Active Requests</h3></div>
                {renderActiveRequests}
                <hr />
            </div>
        );
    }
}

export default AdminHomePage;



/** WEBPACK FOOTER **
 ** ./src/components/Admin/AdminHomePage/AdminHomePage.js
 **/